import { requestPending, requestFail, stopSpinner } from "./loginSlice"
import { loginApi } from "../../apis/loginApi"

import { toast } from "react-toastify"
import { getUserProfile, userLogOut } from "../admin-dashboard-page/userAction"
import { loginSuccess, loginAuto } from "../admin-dashboard-page/userSlice"
import { tokenAPI } from "../../apis/tokenAPI"

export const sendLogin = (formData) => async (dispatch) => {
  try {
    dispatch(requestPending())
    const result = await loginApi(formData)

    const { accessJWT, refreshJWT } = result

    accessJWT && window.sessionStorage.setItem("accessJWT", accessJWT)
    refreshJWT && window.localStorage.setItem("refreshJWT", refreshJWT)

    result.status === "success"
      ? dispatch(stopSpinner()) &&
        dispatch(loginSuccess()) &&
        dispatch(getUserProfile())
      : toast.error(result.message) && dispatch(requestFail(result))
  } catch (error) {
    const err = {
      status: "error",
      message: error.message,
    }
    toast.error(error.message)
    dispatch(requestFail(err))
  }
}

export const userAutoLogin = () => async (dispatch) => {
  const accessJWT = sessionStorage.getItem("accessJWT")
  const refreshJWT = localStorage.getItem("refreshJWT")

  if (accessJWT) {
    dispatch(loginAuto()) && dispatch(getUserProfile())
    return
  }

  if (!accessJWT && refreshJWT) {
    //call the server to get new access token
    const result = await tokenAPI(refreshJWT)
    if (result?.accessJWT) {
      window.sessionStorage.setItem("accessJWT", result.accessJWT)
      return dispatch(loginAuto()) && dispatch(getUserProfile())
    }
  }
  dispatch(userLogOut())
}
